import { render, staticRenderFns } from "./AreaChartTy.vue?vue&type=template&id=0d18a685&scoped=true"
import script from "./AreaChartTy.vue?vue&type=script&lang=js"
export * from "./AreaChartTy.vue?vue&type=script&lang=js"
import style0 from "./AreaChartTy.vue?vue&type=style&index=0&id=0d18a685&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d18a685",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d18a685')) {
      api.createRecord('0d18a685', component.options)
    } else {
      api.reload('0d18a685', component.options)
    }
    module.hot.accept("./AreaChartTy.vue?vue&type=template&id=0d18a685&scoped=true", function () {
      api.rerender('0d18a685', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chart/AreaChartTy.vue"
export default component.exports